import { t } from 'i18next';

import { ErrorResponseErrorItemCodeLicense } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeLicense, string> => ({
  'license:missing_design_tool_access': t('license.missingDesignToolAccess', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du saknar rättigheter för Design.',
  }),
  'license:access_denied': t('license.accessDenied', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du har inte åtkomst till licensen.',
  }),
  'license:access_denied_to_remove_subscription': t('license.accessDeniedToRemoveSubscription', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du har inte rättighet att ta bort prenumerationen från licensen.',
  }),
  'license:not_found': t('license.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Licensen kunde ej hittas.',
  }),
  'license:subscription_is_already_active': t('license.subscriptionIsAlreadyActive', {
    ns: 'apiErrorCodes',
    defaultValue: 'Licensen har redan köpts.',
  }),
  'license:license_of_type_already_exists': t('license.licenseOfTypeAlreadyExists', {
    ns: 'apiErrorCodes',
    defaultValue: 'En licens existerar redan. Kontakta SkyMap support.',
  }),
  'license:user_has_no_valid_license_for_company': t('license.userHasNoValidLicenseForCompany', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du saknar giltig licens till aktuellt företag.',
  }),
});
